export default __webpack_public_path__ + "static/media/mic.3b25813a.svg";